import { useMask } from '@react-input/mask';
import React from 'react';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { ConstantService } from '../../../../services/ConstantService';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import CustomSwitch from '../../../../components/CustomSwitch';
import CustomNumberInput from '../../../../components/CustomNumberInput';

interface Props {
    accountingInformationRef: any
    selectedCommercialType: CustomSingleSelectModel | undefined
    tckn: string | undefined
    setTckn: React.Dispatch<React.SetStateAction<string | undefined>>
    vkn: string | undefined
    setVkn: React.Dispatch<React.SetStateAction<string | undefined>>
    setSelectedCommercialType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    taxOffice: string | undefined
    setTaxOffice: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedPaymentType: CustomSingleSelectModel | undefined
    selectedMaturityPeriod: CustomSingleSelectModel | undefined
    setSelectedMaturityPeriod: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedPaymentType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedInvoiceCurrencyType: CustomSingleSelectModel | undefined
    setSelectedInvoiceCurrencyType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedEArchiveType: CustomSingleSelectModel | undefined
    setSelectedEArchiveType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedEArchiveSendType: CustomSingleSelectModel | undefined
    setSelectedEArchiveSendType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    abnNumber: string | undefined
    setAbnNumber: React.Dispatch<React.SetStateAction<string | undefined>>
    canBeEdited: boolean
    isWithholding: boolean
    setIsWithholding: React.Dispatch<React.SetStateAction<boolean>>
    mernisNo: string | undefined
    setMernisNo: React.Dispatch<React.SetStateAction<string | undefined>>
}

const AccountingInformation = ({
    accountingInformationRef,
    selectedCommercialType,
    tckn,
    setTckn,
    vkn,
    setVkn,
    setSelectedCommercialType,
    taxOffice,
    setTaxOffice,
    selectedPaymentType,
    selectedMaturityPeriod,
    setSelectedMaturityPeriod,
    setSelectedPaymentType,
    selectedInvoiceCurrencyType,
    setSelectedInvoiceCurrencyType,
    selectedEArchiveType,
    setSelectedEArchiveType,
    selectedEArchiveSendType,
    abnNumber,
    setAbnNumber,
    setSelectedEArchiveSendType,
    canBeEdited,
    isWithholding,
    setIsWithholding,
    mernisNo,
    setMernisNo,
}: Props) => {
    const tcknRef = useMask({ mask: '___________', replacement: { _: /\d/ } });
    const vknRef = useMask({ mask: '__________', replacement: { _: /\d/ } });

    return (
        <div className='containerPart' ref={accountingInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Muhasebe Bilgileri</h4>

                    <div className='row'>
                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Ticari Türü</label>

                                <CustomSingleSelect
                                    disabled={!canBeEdited}
                                    selectedValue={selectedCommercialType}
                                    onChange={(selectedValue) => {
                                        setTckn('');
                                        setVkn('');
                                        setSelectedCommercialType(selectedValue);
                                    }}
                                    insertable={{
                                        onSubmit: { code: 'COMPANY_COMMERCIAL_TYPE' }
                                    }}
                                    onMenuOpen={() => ConstantService.getConstantList('COMPANY_COMMERCIAL_TYPE')}
                                    labelName='value'
                                    valueName='constantId'
                                    additionalValue1Name='additionalValue1'
                                />
                            </div>

                            {
                                (selectedCommercialType && selectedCommercialType?.additionalValue1 == "1") && (
                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">TC Kimlik No</label>
                                        <input disabled={!canBeEdited} ref={tcknRef} style={{ border: '1px solid #F1F1F4' }} value={tckn} onChange={(e) => setTckn(e.target.value)} className="form-control form-control-solid" />
                                    </div>
                                )
                            }

                            {
                                (selectedCommercialType && selectedCommercialType?.additionalValue1 == "2") && (
                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Vergi Kimlik No</label>
                                        <input disabled={!canBeEdited} ref={vknRef} style={{ border: '1px solid #F1F1F4' }} value={vkn} onChange={(e) => setVkn(e.target.value)} className="form-control form-control-solid" />
                                    </div>
                                )
                            }

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Vergi Dairesi</label>
                                <input disabled={!canBeEdited} style={{ border: '1px solid #F1F1F4' }} value={taxOffice} onChange={(e) => setTaxOffice(e.target.value)} type="text" className="form-control form-control-solid" />
                            </div>

                            <div className='mt-5'>
                                <CustomSwitch
                                    labelText='Tevkifat Sorumlusu Mu?'
                                    isActive={isWithholding}
                                    setIsActive={setIsWithholding}
                                />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Ödeme Şekli</label>

                                <CustomSingleSelect
                                    disabled={!canBeEdited}
                                    selectedValue={selectedPaymentType}
                                    onChange={(selectedValue) => {
                                        setSelectedMaturityPeriod(undefined);
                                        setSelectedPaymentType(selectedValue);
                                    }}
                                    insertable={{
                                        onSubmit: { code: 'COMPANY_PAYMENT_TYPE' }
                                    }}
                                    onMenuOpen={() => ConstantService.getConstantList('COMPANY_PAYMENT_TYPE')}
                                    labelName='value'
                                    valueName='constantId'
                                    additionalValue1Name='additionalValue1'
                                />
                            </div>

                            {
                                (selectedPaymentType && selectedPaymentType.additionalValue1 == "2") && (
                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Vade Süresi</label>

                                        <CustomSingleSelect
                                            disabled={!canBeEdited}
                                            selectedValue={selectedMaturityPeriod}
                                            onChange={setSelectedMaturityPeriod}
                                            insertable={{
                                                onSubmit: { code: 'COMPANY_MATURITY_PERIOD' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('COMPANY_MATURITY_PERIOD')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                )
                            }


                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Fatura Döviz Cinsi</label>

                                <CustomSingleSelect
                                    disabled={!canBeEdited}
                                    selectedValue={selectedInvoiceCurrencyType}
                                    onChange={setSelectedInvoiceCurrencyType}
                                    onMenuOpen={() => ConstantService.getConstantList('CURRENCY', undefined, undefined)}
                                    labelName='additionalValue1'
                                    valueName='constantId'
                                />
                            </div>

                            <div className='mt-5'>
                                <CustomNumberInput labelText='Mersis No' value={mernisNo} setValue={setMernisNo} maxLength={16} />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">E-Arşiv Tipi</label>

                                <CustomSingleSelect
                                    disabled={!canBeEdited}
                                    selectedValue={selectedEArchiveType}
                                    onChange={setSelectedEArchiveType}
                                    insertable={{
                                        onSubmit: { code: 'E_ARCHIVE_TYPE' }
                                    }}
                                    onMenuOpen={() => ConstantService.getConstantList('E_ARCHIVE_TYPE')}
                                    labelName='value'
                                    valueName='constantId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">E-Arşiv Gönderim Şekli</label>

                                <CustomSingleSelect
                                    disabled={!canBeEdited}
                                    selectedValue={selectedEArchiveSendType}
                                    onChange={setSelectedEArchiveSendType}
                                    insertable={{
                                        onSubmit: { code: 'E_ARCHIVE_SEND_TYPE' }
                                    }}
                                    onMenuOpen={(() => ConstantService.getConstantList('E_ARCHIVE_SEND_TYPE'))}
                                    labelName='value'
                                    valueName='constantId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">ABN No</label>
                                <input disabled={!canBeEdited} style={{ border: '1px solid #F1F1F4' }} value={abnNumber} onChange={(e) => setAbnNumber(e.target.value)} type="text" className="form-control form-control-solid" />
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default AccountingInformation;